import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { SystemApiService } from "@cv-invision/core";
import { ProductIdentifierModel } from "../model/product-identifier.model";

@Injectable()
export class ProductIdentifierListService {
	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService
	) { }

    /**
	 * Get a list of Product identifiers by integration name.
	 * @returns An Observable of the HTTP response containing the list of product identifiers.
	 */
	public getProductIdentifiersByIntegrationName(integrationName: string): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/product-identifiers`
		);
	}

    /**
     * Create Product Identifier
     * @returns An Observable of the HTTP response containing the list of product identifiers.
     */
    public createProductIdentifier(integrationName: string, productIdentifier: ProductIdentifierModel): Observable<any> {
        return this.httpClient.post(
            `${this.systemApiService.api.orders}/utils/integrations/${integrationName}/product-identifiers`, productIdentifier
        );
    }

    /**
     * Update Product Identifier
     * @returns An Observable of the HTTP response containing the list of product identifiers.
     */
    public updateProductIdentifier(integrationName: string, productIdentifier: ProductIdentifierModel): Observable<any> {
        return this.httpClient.put(
            `${this.systemApiService.api.orders}/utils/integrations/${integrationName}/product-identifiers/${productIdentifier.id}`, productIdentifier
        );
    }

    /**
	 * Delete Product Identifier
	 * @returns An Observable of the HTTP response containing the list of Product identifiers.
	 */
	public deleteProductIdentifier(integrationName: string, productIdentifier: ProductIdentifierModel): Observable<any> {
		return this.httpClient.delete(
			`${this.systemApiService.api.orders}/utils/integrations/${integrationName}/product-identifiers/${productIdentifier.id}`
		);
	}

	public create(integrationName: string, model: ProductIdentifierModel): Observable<any> {
		return this.createProductIdentifier(integrationName, model);
	}

	public update(integrationName: string, model: ProductIdentifierModel): Observable<any> {
		return this.updateProductIdentifier(integrationName, model);
	}
}